import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import {
  Button,
  Form,
  Field,
  CellGroup,
  Radio,
  RadioGroup,
  Popup,
  DatetimePicker,
  Area,
  Uploader,
  Picker,
  List,
  Search,
  Cell,
} from "vant";
import "vant/lib/index.css";

Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Area);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(List);
Vue.use(Search);
Vue.use(Cell);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
